import React, { useState } from 'react';
import { Card, Checkbox, Col, Input, Row, Space, Tag, Typography } from 'antd';
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';

const { Text } = Typography;
const { TextArea } = Input;

interface TraduccionSpScProps {
  item: any;
}

const TraduccionSpSc: React.FC<TraduccionSpScProps> = ({ item }) => {
  const [contenidoSignificativo, setContenidoSignificativo] = useState(false);
  const [contienePreguntas, setContienePreguntas]           = useState(false);
  const [preguntasText, setPreguntasText]                   = useState('');
  const [obsChecked, setObsChecked]                         = useState(false);
  const [obsText, setObsText]                               = useState('');
  const [zoom, setZoom]                                     = useState(1);

  return (
    <Row gutter={[16, 16]} style={{ minHeight: 500 }}>

      {/* ── Columna izquierda: Detalle + Revisión ── */}
      <Col span={24} md={8}>

        {/* Detalle de la comunicación */}
        <Card
          size="small"
          title={<Text strong>Detalle de la comunicación</Text>}
          style={{ marginBottom: 12 }}
          bodyStyle={{ padding: '8px 12px' }}
        >
          <Row gutter={[0, 4]}>
            <Col span={24}><Text type="secondary">Id solicitud: </Text><Text>{item?.id ?? 44}</Text></Col>
            <Col span={24}><Text type="secondary">País: </Text><Text>Ecuador</Text></Col>
            <Col span={24}><Text type="secondary">SC: </Text><Text>{item?.nroSc ?? 4568}</Text></Col>
            <Col span={24}><Text type="secondary">Nombre SC: </Text><Text>{item?.nombreSc ?? 'Mario Rodriguez'}</Text></Col>
            <Col span={24}>
              <Text type="secondary">Estado: </Text>
              <Tag color="blue">{item?.estado ?? 'Traduciendo'}</Tag>
            </Col>
          </Row>
        </Card>

        {/* Revisión de la comunicación */}
        <Card
          size="small"
          title={<Text strong>Revisión de la comunicación</Text>}
          bodyStyle={{ padding: '12px' }}
        >
          <Row gutter={[0, 12]}>

            {/* Contenido significativo */}
            <Col span={24}>
              <Checkbox
                checked={contenidoSignificativo}
                onChange={e => setContenidoSignificativo(e.target.checked)}
              >
                <Text>Comunicación SP con contenido significativo</Text>
              </Checkbox>
            </Col>

            {/* Contiene preguntas */}
            <Col span={24}>
              <Checkbox
                checked={contienePreguntas}
                onChange={e => setContienePreguntas(e.target.checked)}
              >
                <Text>Contiene preguntas</Text>
              </Checkbox>
              {contienePreguntas && (
                <TextArea
                  rows={3}
                  style={{ marginTop: 6 }}
                  placeholder="Ingrese las preguntas del patrocinador..."
                  value={preguntasText}
                  onChange={e => setPreguntasText(e.target.value)}
                />
              )}
            </Col>

            {/* Observaciones del traductor */}
            <Col span={24}>
              <Checkbox
                checked={obsChecked}
                onChange={e => setObsChecked(e.target.checked)}
              >
                <Text>Observaciones del traductor</Text>
              </Checkbox>
              {obsChecked && (
                <TextArea
                  rows={3}
                  style={{ marginTop: 6 }}
                  placeholder="Ingrese sus observaciones..."
                  value={obsText}
                  onChange={e => setObsText(e.target.value)}
                />
              )}
            </Col>

          </Row>
        </Card>
      </Col>

      {/* ── Columna derecha: Imagen de la comunicación ── */}
      <Col span={24} md={16}>
        <Card
          title={<Text strong>Comunicación original (SP)</Text>}
          bodyStyle={{ padding: 12 }}
          style={{ height: '100%' }}
        >
          {/* Imagen placeholder */}
          <div
            style={{
              border: '2px dashed #d9d9d9',
              borderRadius: 4,
              background: '#fafafa',
              minHeight: 360,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: `scale(${zoom})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s',
            }}
          >
            <Text type="secondary" style={{ fontSize: 13 }}>
              [ Imagen de la carta SP ]
            </Text>
          </div>

          {/* Controles de imagen */}
          <Row justify="center" align="middle" style={{ marginTop: 12 }}>
            <Space size={16}>
              <SearchOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => setZoom(z => Math.min(z + 0.1, 2))}
              />
              <MinusCircleOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => setZoom(z => Math.max(z - 0.1, 0.5))}
              />
              <PlusCircleOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => setZoom(z => Math.min(z + 0.1, 2))}
              />
              <LeftOutlined  style={{ fontSize: 18, cursor: 'pointer' }} />
              <RightOutlined style={{ fontSize: 18, cursor: 'pointer', color: '#1677ff' }} />
            </Space>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default TraduccionSpSc;
